<div class="flex flex-col gap-[24px] sm:gap-[12px] justify-start items-center">
  <img data-at-empty-image src="{{ imgSrc }}" />
  <h1>{{ header }}</h1>
  <vi-text>{{ content }}</vi-text>
  <button
    data-at-empty-btn
    mat-flat-button
    color="primary"
    [routerLink]="[redirectLink]"
    *ngIf="redirectLink"
  >
    {{ redirectBtn }}
  </button>
</div>
